import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import UpCircleFilledSvg from "@ant-design/icons-svg/es/asn/UpCircleFilled";
import AntdIcon from "../components/AntdIcon";
var UpCircleFilled = function UpCircleFilled(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: UpCircleFilledSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  UpCircleFilled.displayName = 'UpCircleFilled';
}
export default /*#__PURE__*/React.forwardRef(UpCircleFilled);